module.exports = __webpack_public_path__ + "img/ico-interactive-platform_2.8baf88ee.svg";